export const cacheStaleTime = 1000 * 60 * 2;
export const standardInputDebounce = 400;
export const mainAppBarHeight = 50;
export const mainToolbarBarHeight = 50;
export const bottomToolbarHeight = 32;
export const panelHeaderHeight = 60;
export const snackBarStorageID = 'snackbar-storage';
export const buttonStorageID = 'button-storage';
export const breadcrumbLinkStorageID = 'breadcrumb-link-storage';
export const selectedMapperTabKey = 'DataMapperSelectedTab';
export const themeKey = 'Theme';
export const localeKey = 'Locale';
